angular.module 'app'
.controller 'PlayVideoCtrl', ($scope, $http, $stateParams, $state, $sce, config, Storage, dialogs, growl, SweetAlert, FileUploader,ueditorConfig, $uibModalInstance, data) ->

  $scope.ui =
    link: $sce.trustAsResourceUrl(data.link)


  $scope.cancel = ->
    $uibModalInstance.close 'Cancel'
